//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CompanyDrawer from "./modules/CompanyDrawer";
import CompanySiteInfoDrawer from '@views/yongchun/base/modules/CompanySiteInfoDrawer.vue';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { downloadFile } from '@/api/manage';
import { queryAreaTreeList } from '@/api/api';
import { nextTick } from "../../../../public/EZUIKit/js/flv.min";
export default {
  name: 'CompanyList',
  mixins: [JeecgListMixin],
  components: {
    CompanyDrawer: CompanyDrawer,
    CompanySiteInfoDrawer: CompanySiteInfoDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/company',
      pageTitle: '一企一档',
      areaTree: [],
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'companyName',
        colName: 'company_name',
        title: '企业全称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'type_dictText',
        colName: 'type',
        title: '企业类别',
        align: 'center',
        sorter: true
      }, // {
      //   dataIndex: 'industry',
      //   colName: 'industry',
      //   title: '所属行业',
      //   align: 'center',
      //   sorter: true
      // },
      {
        dataIndex: 'areaName',
        colName: 'area_id',
        title: '所属区域',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'address',
        colName: 'address',
        title: '企业地址',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'legalPerson',
        colName: 'legal_person',
        title: '法人代表',
        align: 'center',
        sorter: true
      }, // {
      //   dataIndex: 'website',
      //   colName: 'website',
      //   title: '官网',
      //   align: 'center',
      //   sorter: true
      // },
      {
        dataIndex: 'contact',
        colName: 'contact',
        title: '联系人',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'contactTel',
        colName: 'contact_tel',
        title: '联系人电话',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'companyCode',
        colName: 'company_code',
        title: '组织机构代码',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'creditCode',
        colName: 'credit_code',
        title: '统一社会信用代码',
        align: 'center',
        sorter: true
      }, // {
      //   dataIndex: 'sDate',
      //   colName: 's_date',
      //   title: '成立日期',
      //   align: 'center',
      //   sorter: true
      // },
      // {
      //   dataIndex: 'businessTerm',
      //   colName: 'business_term',
      //   title: '营业期限',
      //   align: 'center',
      //   sorter: true
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      currentUrl: '',
      autoLoadInit: false
    };
  },
  created: function created() {
    this.currentUrl = window.location.href;

    if (this.currentUrl.indexOf('/CompanyList/breed') != -1) {
      this.queryParam.type = '1';
    } else {
      delete this.queryParam.type;
    }

    this.loadAreaTree();
    this.loadData();
  },
  computed: {},
  watch: {
    $route: function $route(to, form) {
      this.currentUrl = window.location.href;

      if (this.currentUrl.indexOf('/CompanyList/breed') != -1) {
        this.queryParam.type = '1';
      } else {
        delete this.queryParam.type;
      }

      this.loadData();
    }
  },
  methods: {
    onDateSDate: function onDateSDate(value, dateArray) {
      this.queryParam.sDateStart = dateArray[0];
      this.queryParam.sDateEnd = dateArray[1];
    },
    //  导出模板
    handleExportTemplate: function handleExportTemplate(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = this.pageTitle + '导出文件模板';
      }

      var url = '/site/company/exportXlsTemplate';
      downloadFile(fileName + '.xls', url);
    },
    modalFormOk: function modalFormOk() {
      if (this.currentUrl.indexOf('/CompanyList/breed') != -1) {
        this.searchReset({
          type: '1'
        });
      } else {
        this.searchReset();
      } // 新增/修改 成功时，重载列表


      this.loadData();
    },
    loadAreaTree: function loadAreaTree() {
      var _this = this;

      var that = this;
      that.areaTree = []; // 流域
      // 区域

      queryAreaTreeList({
        status: '1'
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            temp.key = temp.key;
            that.areaTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    openSiteInfo: function openSiteInfo(record) {
      this.$refs.CompanySiteInfoDrawerRef.companyId = record.id;
      this.$refs.CompanySiteInfoDrawerRef.visible = true;
    }
  }
};